/*eslint react-hooks/exhaustive-deps: "off"*/
import React, {useCallback, useContext, useState} from "react";
import MapPropsContext from "../MapPropsContext";
import {Title} from "./Common";
import {Checkbox, Col, Row} from "antd";


function CheckboxGroupWithCheckAll({ title, fieldName, options, colSpan }) {
  const {
    widgetState,
    onChangeWidgetState,
    iconDict,
  } = useContext(MapPropsContext);
  const fieldValue = widgetState[fieldName];

  const [state, setState] = useState({
    indeterminate: (fieldValue.length < options.length),
    checkAll: (fieldValue.length === options.length),
  });

  const onCheckAllChange = useCallback(({ target: { checked } }) => {
    setState({
      indeterminate: false,
      checkAll: checked,
    });
    onChangeWidgetState({
      target: {
        name: fieldName,
        value: !checked ? [] : options.map(({ value }) => value),
      }}
    );
  }, [options]);

  const onChange = useCallback((checkedValues) => {
    setState({
      indeterminate: !!checkedValues.length && checkedValues.length < options.length,
      checkAll: (checkedValues.length === options.length),
    });

    onChangeWidgetState({target: {name: fieldName, value: checkedValues}})
  }, [onChangeWidgetState, setState, options]);

  return (
    <>
      <Title extra={
               <Checkbox checked={state.checkAll} indeterminate={state.indeterminate} onChange={onCheckAllChange}>
                 전체 선택
               </Checkbox>
             }>
        {title}
      </Title>
      <Checkbox.Group name={fieldName}
                      value={fieldValue}
                      onChange={onChange}
                      size={"small"}
                      style={{ width: '100%', height: 150, overflowY: "scroll"}}>
        <Row>
          {options.map(({ value, label, iconCode }, index) => {
            const { data, width, height } = iconDict[iconCode] || {};
            const iconWidth = 12;
            const ratio = iconWidth / width;
            const iconHeight = Math.floor(height * ratio);
            return (
              <Col span={colSpan} key={index}>
                <Checkbox value={value}>
                  {data && <img src={data} style={{ width: iconWidth, height: iconHeight, marginRight: 5, marginBottom: 4}} alt={""}/>}
                  {label}
                </Checkbox>
              </Col>
            );
          })}
        </Row>
      </Checkbox.Group>
    </>
  );
}


export default CheckboxGroupWithCheckAll;
